import type { CredentialingStatus } from '../../types';

export const CREDENTIALING_PAGE_SIZE = 25;
export const CREDENTIALING_STATUS_LABELS: Record<CredentialingStatus, string> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  complete: 'Complete',
};
